import { gql } from '@apollo/client';

// ================== 주문 관련 ==================
export const GET_MY_ORDERS_QUERY = gql`
  query GetMyOrders {
    myOrders {
      id
      orderNumber
      status
      totalAmount
      createdAt
      orderItems {
        id
        quantity
        price
        product {
          name
          images
        }
      }
    }
  }
`;

export const GET_ALL_ORDERS_QUERY = gql`
  query GetAllOrders {
    orders {
      id
      orderNumber
      status
      totalAmount
      createdAt
      user {
        id
        name
        email
      }
      orderItems {
        id
        quantity
        price
        product {
          name
          images
        }
      }
    }
  }
`;

export const GET_ORDER_BY_ID_QUERY = gql`
  query GetOrderById($id: Int!) {
    order(id: $id) {
      id
      orderNumber
      status
      totalAmount
      createdAt
      updatedAt
      user {
        id
        name
        email
      }
      orderItems {
        id
        quantity
        price
        product {
          id
          name
          images
        }
      }
    }
  }
`;

export const CREATE_ORDER_MUTATION = gql`
  mutation CreateOrder($cartItemIds: [Int!]!) {
    createOrder(cartItemIds: $cartItemIds) {
      id
      orderNumber
      status
      totalAmount
      createdAt
    }
  }
`;

export const UPDATE_ORDER_STATUS_MUTATION = gql`
  mutation UpdateOrderStatus($id: Int!, $status: OrderStatus!) {
    updateOrderStatus(id: $id, status: $status) {
      id
      status
      updatedAt
    }
  }
`; 